import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useMHRDischargeModal = (customerID: string) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrDischarge($customerID: String) {
        mhrDischarge(customerId: $customerID) {
          html
          ok
          error
          documentId
          uniqueRepositoryId
        }
      }
    `),
    {
      variables: {
        customerID,
      },
    },
  );

  return {
    ok: data?.mhrDischarge?.ok ?? false,
    loading,
    error: error ? 'Error loading latest discharge summary' : data?.mhrDischarge?.error,
    html: data?.mhrDischarge?.html,
    documentId: data?.mhrDischarge?.documentId,
    uniqueRepositoryId: data?.mhrDischarge?.uniqueRepositoryId,
  };
};
